export interface LoginCredentials {
  email: string;
  password: string;
}

export const LOGIN_FAILURE_CODES = {
  INVALID_EMAIL: "INVALID_EMAIL",
  EMPTY_EMAIL: "EMPTY_EMAIL",
  EMPTY_PASSWORD: "EMPTY_PASSWORD",
} as const;

export type LoginFailureCode =
  (typeof LOGIN_FAILURE_CODES)[keyof typeof LOGIN_FAILURE_CODES];
